"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ProjectDriversItem = require("./ProjectDriversItem");

var _ProjectDriversItem2 = _interopRequireDefault(_ProjectDriversItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectDriversList = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectDriversList, _Component);

  function ProjectDriversList() {
    (0, _classCallCheck3.default)(this, ProjectDriversList);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectDriversList.__proto__ || (0, _getPrototypeOf2.default)(ProjectDriversList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectDriversList, [{
    key: "render",
    value: function render() {
      if (!this.props.userList || !this.props.userList.length) {
        return this.renderEmptyMessage();
      }
      return this.renderCart();
    }
  }, {
    key: "renderEmptyMessage",
    value: function renderEmptyMessage() {
      return _react2.default.createElement(
        "div",
        { className: "voucher-order-cart" },
        _react2.default.createElement(
          "p",
          null,
          "Ilmoituksella ei ole viel\xE4 kuljettajia."
        )
      );
    }
  }, {
    key: "renderCart",
    value: function renderCart() {
      return _react2.default.createElement(
        "table",
        { className: "table voucher-order-cart" },
        _react2.default.createElement(
          "thead",
          null,
          _react2.default.createElement(
            "tr",
            null,
            _react2.default.createElement(
              "th",
              null,
              "Aktiivinen:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "Email:"
            ),
            _react2.default.createElement("th", null)
          )
        ),
        _react2.default.createElement(
          "tbody",
          null,
          this.renderItems()
        )
      );
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      if (!this.props.userList || !this.props.userList.length) {
        return null;
      }

      return this.props.userList.map(function (item, index) {
        return _react2.default.createElement(_ProjectDriversItem2.default, {
          key: index,
          item: item,
          updateProjectDriverByEmail: _this2.props.updateProjectDriverByEmail,
          projectId: _this2.props.projectId
        });
      });
    }
  }]);
  return ProjectDriversList;
}(_react.Component), _class.propTypes = {
  userList: _react.PropTypes.array,
  updateProjectDriverByEmail: _react.PropTypes.func
}, _temp);
exports.default = ProjectDriversList;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/ProjectDriversList.js
 ** module id = 1175
 ** module chunks = 0
 **/